import {readonly, ref} from 'vue';
import type {Router} from 'vue-router';

/**
 * Флаг «идёт переход между маршрутами».
 *
 * Все страницы грузятся динамическим import(), а оба <router-view> форсированы через :key,
 * поэтому на время загрузки чанка старый DOM уже уничтожен, а новый ещё не пришёл —
 * на медленной сети это пустой экран. Флаг питает полосу прогресса в App.vue.
 */
const isNavigating = ref(false);

export const isRouteLoading = readonly(isNavigating);

export function installNavigationProgress(router: Router): void {
    router.beforeEach((to, from) => {
        // Смена только query/hash чанк не грузит — полоса там была бы мерцанием.
        if (to.matched[to.matched.length - 1] === from.matched[from.matched.length - 1]) return;
        isNavigating.value = true;
    });

    router.afterEach(() => {
        isNavigating.value = false;
    });

    // Отменённая или упавшая навигация тоже обязана погасить полосу.
    router.onError(() => {
        isNavigating.value = false;
    });
}
